<template>
  <el-form :model="formData" ref="form">
    <el-form-item :label="$t('lang.准备时间') + '：'">

      <div class="select-box">
        <div>
          <el-select
              filterable
              allow-create
              default-first-option
              :disabled="disabled"
              class="select"
              v-model="formData.prepareHours"
              :placeholder="$t('lang.请选择')">
            <el-option v-for="prepareHours in 25" :key="'prepareHours_' + prepareHours" :label="prepareHours -1" :value="prepareHours -1"></el-option>
          </el-select>
          <span>h</span>
        </div>

        <div>
          <el-select
              filterable
              allow-create
              default-first-option
              :disabled="disabled"
              class="select"
              v-model="formData.prepareMinutes"
              :placeholder="$t('lang.请选择')">
            <el-option v-for="prepareMinutes in 61" :key="'prepareMinutes_' + prepareMinutes" :label="prepareMinutes -1" :value="prepareMinutes -1"></el-option>
          </el-select>
          <span>min</span>
        </div>
      </div>

    </el-form-item>

    <el-form-item :label="$t('lang.制作时间') + '：'">

      <div class="select-box">
        <div>
          <el-select
              filterable
              allow-create
              default-first-option
              :disabled="disabled"
              class="select"
              v-model="formData.makeHours"
              :placeholder="$t('lang.请选择')">
            <el-option v-for="makeHours in 25" :key="'makeHours_' + makeHours" :label="makeHours -1" :value="makeHours -1"></el-option>
          </el-select>
          <span>h</span>
        </div>

        <div>
          <el-select
              filterable
              allow-create
              default-first-option
              :disabled="disabled"
              class="select"
              v-model="formData.makeMinutes"
              :placeholder="$t('lang.请选择')">
            <el-option v-for="makeMinutes in 61" :key="'makeMinutes_' + makeMinutes" :label="makeMinutes -1" :value="makeMinutes -1"></el-option>
          </el-select>
          <span>min</span>
        </div>
      </div>

    </el-form-item>
    <el-form-item :label="$t('lang.休息时间') + '：'">

      <div class="select-box">
        <div>
          <el-select
              filterable
              allow-create
              default-first-option
              :disabled="disabled"
              class="select"
              v-model="formData.restHours"
              :placeholder="$t('lang.请选择')">
            <el-option v-for="restHours in 25" :key="'restHours_' + restHours" :label="restHours -1" :value="restHours -1"></el-option>
          </el-select>
          <span>h</span>
        </div>

        <div>
          <el-select
              filterable
              allow-create
              default-first-option
              :disabled="disabled"
              class="select"
              v-model="formData.restMinutes"
              :placeholder="$t('lang.请选择')">
            <el-option v-for="restMinutes in 61" :key="'restMinutes_' + restMinutes" :label="restMinutes -1" :value="restMinutes -1"></el-option>
          </el-select>
          <span>min</span>
        </div>
      </div>

    </el-form-item>


    <el-form-item>
      <el-button @click="$router.back()" v-if="disabled">{{ $t('lang.返回') }}</el-button>
      <template v-else>
        <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
        <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
      </template>
      <el-button type="primary" @click="$emit('lastStep')">{{ $t('lang.上一步') }}</el-button>
      <el-button type="primary" @click="$emit('next')">{{ $t('lang.下一步') }}</el-button>
    </el-form-item>

  </el-form>

</template>

<script>
export default {
  name: "UseTime",
  props: {
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      formData: {
        prepareHours: null,
        prepareMinutes: null,
        makeHours: null,
        makeMinutes: null,
        restHours: null,
        restMinutes: null,
      },
      disabled: false,
    }
  },
  activated() {
    this.handleGetData();
  },
  watch: {
    status: {
      handler(state) {
        if(state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(obj) {
        this.$store.commit("CHANGE_RECIPE", {...obj});
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    handleGetData() {
      let {prepareHours, prepareMinutes, makeHours, makeMinutes, restHours, restMinutes } = this.$store.state.recipe;
      let obj = {prepareHours, prepareMinutes, makeHours, makeMinutes, restHours, restMinutes };
      for (const key in obj) {
        this.formData[key] = obj[key];
      }
    },
  }
}
</script>

<style scoped>

.select-box {
  display: flex;
}

.select-box span {
  margin: 0 12px;
  font-weight: bold;
}

.select {
  width: 100px;
}

</style>
